import React from 'react';
import { CModal, CModalBody, CModalHeader } from '@coreui/react';
import OptionConfigurationEditor from './OptionConfigurationEditor';
import './OptionConfigurationModal.css';

const OptionConfigurationModal = ({ option, onSave, onClose, editorContext }) => (
  <CModal
    className="custom-form-builder-theme__editor-modal option-configuration-modal"
    size="lg"
    visible
    backdrop="static"
    onClose={onClose}
  >
    <CModalHeader />
    <CModalBody>
      <OptionConfigurationEditor
        option={option}
        onSave={onSave}
        onClose={onClose}
        editorContext={editorContext}
      />
    </CModalBody>
  </CModal>
);

export default OptionConfigurationModal;
